import { Header } from 'widgets/default/Header';
let PanelHeader = Header;
export { PanelHeader };
